import React from "react";
import ListView from "../Common/Views/ListView";
import Chip from "@mui/material/Chip";

const JobCardsList = ({
    filters = {},
    addButton = false,
    onSelect = null,
    columns = null,
}) => {

    const getStatusColor = (status) => {
        switch (status) {
            case 'DRAFT': return 'default';
            case 'ASSIGNED': return 'info';
            case 'IN_PROGRESS': return 'warning';
            case 'COMPLETED': return 'success';
            case 'CANCELLED': return 'error';
            default: return 'default';
        }
    };

    const getStatusLabel = (status) => {
        const labels = {
            'DRAFT': 'Draft',
            'ASSIGNED': 'Assigned',
            'IN_PROGRESS': 'In Progress',
            'COMPLETED': 'Completed',
            'CANCELLED': 'Cancelled'
        };
        return labels[status] || status;
    };

    const getPriorityColor = (priority) => {
        switch (priority) {
            case 'LOW': return 'default';
            case 'MEDIUM': return 'info';
            case 'HIGH': return 'warning';
            case 'URGENT': return 'error';
            default: return 'default';
        }
    };

    // Columns configuration
    const columnsConfig = {
        jobNumber: {
            key: 'jobNumber',
            label: 'Job #',
            render: row => row.jobNumber
        },
        vehiclePlate: {
            key: 'vehiclePlate',
            label: 'Vehicle',
            render: row => row.vehicle?.registrationNumber || '-'
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => (
                <Chip 
                    label={getStatusLabel(row.status)} 
                    color={getStatusColor(row.status)}
                    size="small"
                />
            )
        },
        priority: {
            key: 'priority',
            label: 'Priority',
            render: row => (
                <Chip 
                    label={row.priority} 
                    color={getPriorityColor(row.priority)}
                    size="small"
                    variant="outlined"
                />
            )
        },
        assignedEmployee: {
            key: 'assignedEmployee',
            label: 'Assigned To',
            render: row => row.assignedEmployee?.name || '-'
        },
        location: {
            key: 'location',
            label: 'Location',
            render: row => row.location?.name || '-'
        },
        createdAt: {
            key: 'createdAt',
            label: 'Created',
            render: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '-'
        },
        billable: {
            key: 'billable',
            label: 'Billable',
            render: row => (
                <Chip 
                    label={row.isInvoicable ? 'Yes' : 'No'} 
                    color={row.isInvoicable ? 'success' : 'warning'}
                    size="small"
                    variant="outlined"
                />
            )
        },
    };

    return (
        <ListView
            title="Job Cards"
            apiPath="/tenants/job-cards"
            filters={filters}
            addButton={addButton}
            addButtonLabel="New Job Card"
            addPath="/sales/job-cards/new"
            rowClickPath={(jobCard) => `/sales/job-cards/${jobCard.id}`}
            onSelect={onSelect}
            columnsConfig={columnsConfig}
            columns={columns || ['jobNumber', 'vehiclePlate', 'status', 'assignedEmployee', 'location', 'createdAt']}
            searchBox={true}
            searchAttributes={[
                { name: 'jobNumber', label: 'Job Number', type: 'text' },
                { name: 'status', label: 'Status', type: 'select', options: [
                    { value: '', label: 'All' },
                    { value: 'DRAFT', label: 'Draft' },
                    { value: 'ASSIGNED', label: 'Assigned' },
                    { value: 'IN_PROGRESS', label: 'In Progress' },
                    { value: 'COMPLETED', label: 'Completed' },
                    { value: 'CANCELLED', label: 'Cancelled' },
                ]},
            ]}
            noResultsMessage="No job cards found"
        />
    );
};

export default JobCardsList;
